import {ExperimentNames, Submissions, getFormId, isAssignedTickets, isTicketed} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useAppSelector} from '../../hooks/runtime'
import {getBuyerDetails} from '../../selectors/checkout'
import {getDefaultFormValuesOld} from '../../selectors/current-member-details'
import {getEvent} from '../../selectors/event'
import {getPlacedOrder} from '../../selectors/placed-order'
import {getFormSubmissions, getRsvpDetails} from '../../selectors/rsvp'
import c from '../classnames.scss'
import {DISABLED_PREFILLED_FORM_FIELDS} from '../form/constants'
import {Form} from '../form/container'
import {WixForm} from '../wix-form/wix-form'
import s from './buyer-details.scss'
import {BuyerDetailsProps} from './interfaces'
import {getInitialValues} from './utils'

export const BuyerDetails = ({editing, onSubmit}: BuyerDetailsProps) => {
  const {experiments} = useExperiments()

  const buyerDetails = useAppSelector(getBuyerDetails)
  const rsvpDetails = useAppSelector(getRsvpDetails)
  const submissions = useAppSelector(getFormSubmissions)
  const defaultFormValues = useAppSelector(getDefaultFormValuesOld)
  const placedOrder = useAppSelector(getPlacedOrder)
  const event = useAppSelector(getEvent)

  const formId = getFormId(event)
  const ticketed = isTicketed(event)
  const initialValues = getInitialValues({ticketed, buyerDetails, rsvpDetails, defaultFormValues, order: placedOrder})
  const disabledFields = initialValues.email ? DISABLED_PREFILLED_FORM_FIELDS : []
  const details = ticketed ? buyerDetails : rsvpDetails
  const assignedTicketsEnabled = ticketed && isAssignedTickets(event)
  const useWixFormsEnabled = experiments.enabled(ExperimentNames.UseWixForms)

  return editing ? (
    <div className={s.container}>
      {useWixFormsEnabled && formId ? (
        <WixForm onSubmit={onSubmit as (data?: Submissions) => void} />
      ) : (
        <Form
          initialValues={initialValues}
          disabledFields={disabledFields}
          hideAdditionalFields={assignedTicketsEnabled}
          onFormSubmit={onSubmit}
        />
      )}
    </div>
  ) : (
    <div
      data-hook={DH.CHECKOUT_BUYER_DETAILS}
      className={classNames(s.details, c.formLabelsFont, c.formLabelsColor, s.opaque)}
    >
      <div>
        {details?.firstName || submissions?.first_name} {details?.lastName || submissions?.last_name}
      </div>
      <div>{details?.email || submissions?.email}</div>
    </div>
  )
}
